import * as ExpoImagePicker from 'expo-image-picker';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import Icon from '@components/Icon';
import Surface from '@components/Surface';
import { logError } from '@helpers/Loggers';
import { getCircleStyle } from '@helpers/Styles';
import { Photo } from '@types';

type ImagePickerProps = {
  onSelected: (image: Photo) => void;
  onError: (error: unknown) => void;
  style: React.ComponentProps<typeof Surface>['style'];
  /** Renders the picker surface as a circle based on its resolved size. */
  circle?: boolean;
  iconSize?: number;
  iconStyle?: React.ComponentProps<typeof Icon>['style'];
  testID?: string;
};

export default function ImagePicker({
  onSelected,
  onError,
  style,
  circle,
  iconSize = 35,
  iconStyle,
  testID,
}: ImagePickerProps) {
  const pickImage = async () => {
    try {
      const result = await ExpoImagePicker.launchImageLibraryAsync({
        mediaTypes: ['images'],
        allowsEditing: true,
        aspect: [4, 3],
        quality: 1,
        allowsMultipleSelection: false,
      });
      // TODO: handle the new `result` type more elegantly
      if (!result.canceled && result.assets && result.assets.length >= 1) {
        try {
          onSelected(result.assets[0]);
        } catch (error) {
          onError(error);
        }
      }
    } catch (error) {
      logError(error);
    }
  };

  return (
    <Pressable onPress={pickImage} testID={testID}>
      <Surface
        style={[
          styles.surface,
          style,
          circle ? getCircleStyle([styles.surface, style]) : undefined,
        ]}>
        <Icon name="camera-plus-outline" size={iconSize} style={iconStyle} />
      </Surface>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  surface: {
    alignItems: 'center',
    height: 100,
    justifyContent: 'center',
    width: 100,
  },
});
